import React from "react";
import { connect } from "react-redux";

import { EntityType } from "@mapmycustomers/shared/types/entity";

import MapFilter, { getEntityTypeByMapFilter } from "@app/scene/reports/enums/MapFilter";
import { fetchActivityCardListData } from "@app/scene/reports/store/actions";
import ActivityCardData from "@app/scene/reports/store/ActivityCardData";

import ActivityList from "./ActivityList";
import CompanyList from "./CompanyList";
import PeopleList from "./PeopleList";

interface Props {
  activityCardData: ActivityCardData;
  filter: MapFilter;
  onLoadData: (page: number) => void;
}

const PinList: React.FC<Props> = ({ activityCardData, filter, onLoadData }) => {
  const entityType = getEntityTypeByMapFilter(filter);

  switch (entityType) {
    case EntityType.ACTIVITY:
      return (
        <ActivityList
          activities={activityCardData.activities}
          filter={filter}
          onLoadData={onLoadData}
          page={activityCardData.listPageNumber}
          total={activityCardData.totalActivities}
        />
      );
    case EntityType.COMPANY:
      return (
        <CompanyList
          companies={activityCardData.companies}
          filter={filter}
          onLoadData={onLoadData}
          page={activityCardData.listPageNumber}
          total={activityCardData.totalCompanies}
        />
      );
    case EntityType.PERSON:
      return (
        <PeopleList
          filter={filter}
          onLoadData={onLoadData}
          page={activityCardData.listPageNumber}
          people={activityCardData.people}
          total={activityCardData.totalPeople}
        />
      );
    default:
      return null;
  }
};

const mapDispatchToProps = {
  onLoadData: fetchActivityCardListData.request,
};

export default connect(null, mapDispatchToProps)(PinList);
